import axios from "axios"
import { useState } from "react"
import Swal from "sweetalert2"


const AdminPage = () => {

  const [disabled, setDisabled] = useState(false)

  const updateWebsite = (isTest = 'false') => {
    setDisabled(true)
    axios.post(`/api/admin/pull-changes-from-github?istest=${isTest}`).then(() => {
      Swal.fire({ icon: "success", "text": "Changes pulled to " + (isTest ? "admin " : "client ") + "Website" })
      setDisabled(false)
    }).catch((e) => {

      Swal.fire({ icon: 'error', "text": "Changes pulled to " + (isTest ? "admin " : "client ") + "Website" })
      console.log(e)
    })
  }
  const [isTestWebsite, setIsTestWebsite] = useState(window.location.host == "trends.fastfashion.live")
  const [isClientWebsite, setIsClientWebsite] = useState(window.location.host == "admin.fastfashion.live")



  return <div>
    <div className="flex justify-center bg-slate-100 py-2 font-semibold ">
      <a href={'/admin/passcodes'} target='_blank' className="px-2 py-1 hover:underline">Passcodes</a>
      <a href={'/admin/curator-track'} target='_blank' className="px-2 py-1 hover:underline">Curator Track</a>
    </div>

    <div className="flex justify-center my-4">
      <div className="mx-2">
        {!isClientWebsite ? <button className="primary-btn" onClick={() => {
          updateWebsite(false)
        }}
          disabled={disabled}
        >Pull Changes</button> : null}
      </div>
      <div className="mx-2">
        {!isTestWebsite ? <button
          className="primary-btn"
          onClick={() => {
            updateWebsite(true)
          }}
          disabled={disabled}
        >Pull Changes To Test Website</button> : null}
      </div>
    </div>
  </div>
}

export default AdminPage
